// extracted by mini-css-extract-plugin
export default {"fullWidth":"Vo-z","image":"Wo-z","lazyLoadPicture":"Xo-z","lazyLoadSpinner":"Yo-z","lazyLoadSpin":"Zo-z","lazyLoadImage":"_o-z","hasStyledAspectRatio":"ap-z"};